<div class="fixed inset-0 flex items-center justify-center overflow-y-auto py-6">
    <div class="w-full max-w-md">
        <div class="flex items-center justify-center mb-8">
            <img src="assets/brand/ai-lens-logo.svg" alt="AI Lens" class="h-10 w-auto" />
        </div>

        <div class="card border border-base-300 shadow-sm">
            <div class="card-body">
                <h2 class="text-[18px] font-bold tracking-tight text-gray-900">Sign in to Clinical AI Studio</h2>
                <p class="text-[13px] text-gray-500">Use your organization account to continue.</p>

                <form (ngSubmit)="onSubmit()" class="mt-5 space-y-4">
                    <label class="block">
                        <span
                            class="text-[11px] font-semibold tracking-wide uppercase text-gray-700">Email</span>
                        <input type="email" name="email" [(ngModel)]="email" required autocomplete="username"
                            placeholder="you@organization.com"
                            class="input input-bordered w-full mt-1.5 h-10 text-[13px]" />
                    </label>
                    <label class="block">
                        <span
                            class="text-[11px] font-semibold tracking-wide uppercase text-gray-700">Password</span>
                        <input type="password" name="password" [(ngModel)]="password" required
                            autocomplete="current-password" placeholder="Enter your password"
                            class="input input-bordered w-full mt-1.5 h-10 text-[13px]" />
                    </label>
                    <button type="submit" class="btn btn-primary w-full" [disabled]="submitting()">
                        {{ submitting() ? 'Signing in…' : 'Sign in' }}
                    </button>
                </form>
                <p class="mt-4 text-[12px] text-gray-500 text-center">
                    Don't have an account?
                    <a routerLink="/signup"
                        class="font-semibold text-primary hover:underline underline-offset-2">
                        Sign up
                    </a>
                </p>
                <p class="mt-2 text-center">
                    <a routerLink="/docs"
                        class="text-[11px] font-semibold text-primary hover:underline underline-offset-2">
                        Open user manual
                    </a>
                </p>
            </div>
        </div>

        <p class="mt-6 text-center text-[11px] text-gray-500 font-mono">
            AI Lens · Clinical Ai Studio
        </p>
    </div>
</div>